/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-03-09 15:05:25
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-08-03 11:02:33
 */
export default class Util {
    static extract2QueryUrl(obj) {
        let query = '?';
        for (let property in obj) {
            if (obj.hasOwnProperty(property)) {
                query = query + property + '=' + obj[property] + '&';
            }
        }
        return query;
    }

    static parse(data) {
        return JSON.parse(data);
    }

    static toJsonStr(obj) {
        return JSON.stringify(obj);
    }

    static randomUUID () {
        let d = new Date().getTime();
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }
}
///-----------------------------------------------临时用的-------------------
// Array.prototype.indexOf = function (val) {
//     for (var i = 0; i < this.length; i++) {
//         if (this[i] == val) return i;
//     }
//     return -1;
// };
Array.prototype.remove = function (val) {
    var index = this.indexOf(val);
    if (index > -1) {
        this.splice(index, 1);
    }
}
/////////---------------------------------------------------------------------------